import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'popover-filters',
  templateUrl: 'popover-filters.html',
})
export class PopoverFilters implements OnInit, OnDestroy {

  @Input() ref: any;
  private subscription: Subscription;

  constructor(params: NavParams, public viewCtrl: ViewController) {
    this.ref = params.get('ref');
  }

  ngOnInit() {
    this.init();
  }

  init() {
    if (this.ref && this.ref.closeEmitter) {
      this.subscription = this.ref.closeEmitter.subscribe(() => {
        this.close();
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/search/popover-filters/popover-filters.ts